<template>
    <div class="w-100 h-100">
    <c-flip-card :top="14" :right="5" v-model="flip">
        <template v-slot:front>
            <div class="w-100 ma-0">
                <crm-entry-tab
                    @saved    = "onSaved"
                    @edit     = "onEdit"
                    @filter   = "onFilter"
                    :incident = "incident"
                    style="margin-top: 2px"
                />

                <v-container fluid class="w-100 pa-0" style="margin-top: -4px;">
                    <v-data-iterator
                        :items         = "journal"
                        :search        = "search"
                        :custom-filter = "cfilter"
                        :items-per-page="1000"
                        :key           = "refreshJournal"
                        hide-default-footer
                    >
                        <template v-slot:header>
                            <v-text-field
                                v-model="search"
                                clearable
                                hide-details
                                append-icon    = "fas fa-search"
                                class          = "pt-0 mt-0 mb-0 pr-1 mt-0"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            ></v-text-field>
                        </template>

                        <template v-slot:default="props">
                            <div class="crm-journal">
                                <crm-entry
                                    v-for="(item, index) in props.items"
                                    :incident  = "incident"
                                    :entry     = "item"
                                    :key       = "item.id"
                                    :class     = "index < props.items.length-1?'mb-3':''"
                                    ref        = "entry"
                                    @edit      = "onEdit"
                                    @saved     = "onSaved"
                                    @deleted   = "onDeleted"
                                    @undeleted = "onUnDeleted"
                                />
                            </div>
                        </template>
                    </v-data-iterator>
                </v-container>
            </div>
        </template>

        <template v-slot:back>
            <div class="white w-100 h-100">
                <c-dms-treeview-incident
                    :incident = "incident"
                    ref       = "dmsoverview"
                />
            </div>
        </template>
    </c-flip-card>
    </div>
</template>

<script>

import Core                 from "@/modules/core/service/Core";
import Inc                  from "@/modules/inc/service/Inc.js";
import Crm                  from "@/modules/crm/service/Crm.ts";
import CrmEntry             from "@/modules/crm/components/main/CrmEntry";
import CrmEntryTab          from "@/modules/crm/components/main/CrmEntryTab";
import CDmsTreeviewIncident from "@/modules/dms/treeview/components/CDmsTreeviewIncident.vue";
import CFlipCard            from "@/modules/core/components/utils/CFlipCard";
import Dms from "@/modules/dms/common/service/Dms";

export default {
    name: "CrmJournal",
    props: {
        incident: {
            required: true,
            type    : Object
        }
    },

    components: {
        CFlipCard,
        CrmEntry,
        CrmEntryTab,
        CDmsTreeviewIncident
    },

    computed: {
        preferences () {
            return this.$store.getters.preferences;
        },

        journal() {
            return this.$store.getters.journal;
        },

        filter () {
            return this.$store.getters.crmFilter;
        }
    },

    data () {
        return {
            flip  : false,
            search: '',
            refreshJournal: 0,
        }
    },

    created() {
        this.$bus.$on(Inc.events.journal, this.load);
        this.$bus.$on(Dms.event.document.refresh, this.load);
    },

    beforeDestroy() {
        this.$bus.$off(Inc.events.journal, this.load);
        this.$bus.$off(Dms.event.document.refresh, this.load);
    },

    watch: {
        flip () {
            if (this.flip) {
                this.$refs.dmsoverview.load();
            } {
                this.$emit("front")
            }
        },
    },

    methods: {
        load () {
            this.$store.dispatch("findJournalByIncident", {
                incidentId   : this.incident.id,
                ignoreDeleted: false
            });
        },

         cfilter (items, search) {
            return items.filter (entry => {
                if (entry.deleted && !this.filter.deleted) {
                    return false;
                }

                if (!this.filterType(entry.type.id)) {
                    return false;
                }

                if (!search) {
                    return true;
                }

                return Core.filter.includes(entry.subject, search) || Core.filter.includes(entry.description, search);
            });
        },

        onEdit (entry) {
             if (!this.$refs.entry) {
                 return;
             }

             this.$refs.entry.forEach(e => {
                   e.startEdit (entry);
             });
        },

        onFilter () {
            this.refreshJournal ++;
        },

        onSaved () {
            this.load();
        },

        onDeleted () {
            this.load();
        },

        onUnDeleted () {
            this.load();
        },

        filterType (type) {

            switch (type) {
                case Crm.journal.type.document:
                    return this.filter.documents;
                case Crm.journal.type.reminder:
                    return this.filter.reminder;
                case Crm.journal.type.clipboard:
                    return this.filter.clipboard;
                case Crm.journal.type.phone:
                    return this.filter.phonecalls;
                case Crm.journal.type.email:
                    return this.filter.mails;
                case Crm.journal.type.notice:
                    return this.filter.comments;
            }

            return true;
        }
    },
}
</script>

<style scoped>

.crm-journal {
    box-shadow: none;
    max-height: 590px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 10px;
    padding-right: 5px;
    width: calc(100% + 1px);
}

div::-webkit-scrollbar {
    width: 7px !important;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3)!important;
    border-radius: 10px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
}

::v-deep .v-input__icon--clear {
    margin-right: -3px;
}

</style>